module.exports = {
	"articleTitle1": "Best Late Night Food: Pizza House ",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Pizza House",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/section/arts/boaa-pizza-house",
	"articleSnippet1": "Apr 2, 2017 ... Between the wide array of options, quick delivery time and deliciousness, Pizza \nHouse never fails to curb a late night craving.",
	"articleSnippet2": "Apr 1, 2016 ... Besides a yearning for a nice and comfortable bed, the warm and luscious \ncheesy bread from Pizza House holds the power to bring these two ...",
	"foodRecommendations": [
		{
			"text": "Can be pricy, but they do have good stuff besides pizza",
			"person": "Andrew Fridenberg"
		}
	],
	"articleTitle2": "Best Late Night Food: Pizza House ",
	"address": "618 Church St, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170412/smk.BOAA_.CharleysRicksPizzaHouseSadako.4.6.17194.jpg?itok=pUhZaLgx",
			"author": "File Photo",
			"caption": ""
		}
	],
	"position": {
		"lat": 42.274266,
		"lng": -83.734956
	},
	"totalMisc": 1,
	"categories": {
		"bestofaa": 1,
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/pizzahouse.json
// module id = 950
// module chunks = 0